import { OptimizelyVariables } from '../../../../hooks/useOptimizelyExperiment';

interface GovernmentDataPartnerBannerVariables {
  title: string;
  description: string;
  disclaimerText: string;
  ctaText: string;
  ctaLink: string;
}

// The variable names and types inside 'variables' come directly from Optimizely.
// see: https://app.optimizely.com/v2/projects/22029240930/flags/manage/government_data_partner_banner_for_sale/variables/edit/CTA_link

export const getGovernmentDataPartnerBannerVariables = (
  variables: OptimizelyVariables,
): GovernmentDataPartnerBannerVariables => {
  return {
    title: variables.title as string,
    description: variables.description as string,
    disclaimerText: variables.disclaimer_text as string,
    ctaText: variables.CTA_text as string,
    ctaLink: variables.CTA_link as string,
  };
};
